function normalizeKey(key: string): string {
	return key?.trim() ?? '';
}

function canUseStorage(storageType: 'local' | 'session'): boolean {
	if (typeof window === 'undefined') {
		return false;
	}

	return storageType === 'local' ? !!window.localStorage : !!window.sessionStorage;
}

export function writeLocalStorage(key: string, value: string): void {
	const normalizedKey = normalizeKey(key);
	if (!normalizedKey || !canUseStorage('local')) {
		return;
	}

	window.localStorage.setItem(normalizedKey, value);
}

export function readLocalStorage(key: string): string | null {
	const normalizedKey = normalizeKey(key);
	if (!normalizedKey || !canUseStorage('local')) {
		return null;
	}

	return window.localStorage.getItem(normalizedKey);
}

export function writeSessionStorage(key: string, value: string): void {
	const normalizedKey = normalizeKey(key);
	if (!normalizedKey || !canUseStorage('session')) {
		return;
	}

	window.sessionStorage.setItem(normalizedKey, value);
}

export function readSessionStorage(key: string): string | null {
	const normalizedKey = normalizeKey(key);
	if (!normalizedKey || !canUseStorage('session')) {
		return null;
	}

	return window.sessionStorage.getItem(normalizedKey);
}
